import React from "react";
import Action from "../actions";

export function setModalBoxReducer(state =
                                       {
                                           isShowing: false,
                                           title: '',
                                           body: (<></>),
                                           buttonType: 1,
                                           buttonCancelLabel: 'Hủy bỏ',
                                           buttonConfirmLabel: 'Xác nhận',
                                           showCloseButton: true,
                                           confirmCallback: null,
                                           cancelCallback: null,
                                           autoClose:true
                                       }
    , action) {

    if (action.type === Action.SHOW_MODAL_BOX) {
        return action.modalbox;
    }
    return state;
}
